import classNames from 'classnames';
import type * as React from 'react';

import americanExpressSvg from './assets/amex.svg';
import discoverSvg from './assets/discover.svg';
import mastercardSvg from './assets/mastercard.svg';
import visaSvg from './assets/visa.svg';

type PaymentLogoType = 'americanExpress' | 'discover' | 'mastercard' | 'visa' | '' | 'Credit card';

const paymentLogos: Record<PaymentLogoType, string | null> = {
  americanExpress: americanExpressSvg,
  discover: discoverSvg,
  mastercard: mastercardSvg,
  visa: visaSvg,
  '': null,
  'Credit card': null,
};

interface PaymentLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /** Name of the image to be shown */
  image: PaymentLogoType;
  /** Text to use for image's alt attribute */
  alt?: string;
  /** Identifier used by QE */
  'data-qe-id'?: string;
}

/**
 * PaymentLogo accepts only payment images from the list below. Pass the string of the payment name from one of these lists.
 *
 * **Note:** When making a new image request, ask Design to provide these with the following criteria:
 * - Size: 84x56
 * - Transparency: yes (fill: none)
 * - Image Type: SVG
 */
export const PaymentLogo: React.FC<PaymentLogoProps> = (props) => {
  const { image, alt = '', 'data-qe-id': qeId, className, ...attributes } = props;

  const classes = classNames(`payment-logo-${image}`, className);

  const src = paymentLogos[image];

  if (!src) {
    return null;
  }

  return <img {...attributes} src={src} alt={alt} className={classes} data-qe-id={qeId} />;
};

PaymentLogo.displayName = 'PaymentLogo';
